import { Component, Inject } from '@angular/core';
import { CONFIG_TOKEN } from 'core/constants';
import { IXMOptions } from 'core/interfaces';
import { UserIdleService } from 'core/services';

@Component({
    selector: 'xm-app',
    templateUrl: './app.html',
    standalone: false
})
export class XmAppComponent {
    constructor(@Inject(CONFIG_TOKEN) config: IXMOptions, userIdleService: UserIdleService) {
        Object.assign(this, { config, userIdleService });
    }
}
